// THE PRE-PAINT KEY (APP_PREPAINT): the ground params a shipped slot (surface/paint, meta.surface.paint) is painted
// with — the TOP class's tunables.gensurf ground (OWNER_RULES 2026-10-31: the device's own tiling flag governs live
// paint only), read by the Build (engine/sched.mjs world fact paint_params) and by the client's hit rule alike.
// Pure; no imports.
export const PAINT_CLASS = 'desktop-dgpu';
// this client build's painter (scripts/build-client.js stamps engine/steps/_prepaint/painter.mjs painterHash; Node: null)
/* global __PAINTER_KEY__ */
export const PAINTER_KEY = typeof __PAINTER_KEY__ !== 'undefined' ? __PAINTER_KEY__ : null;
// gensurf (tunables.gensurf) -> {strata, tiling}: groundgen's own reading of a class's ground (clamped strata, boolean tiling)
export function paintParams(gensurf) {
  const g = (gensurf && gensurf.by_class && gensurf.by_class[PAINT_CLASS] && gensurf.by_class[PAINT_CLASS].ground) || {};
  return { strata: Math.min(1, Math.max(0, +(g.strata || 0))), tiling: !!g.tiling };
}
// THE HIT RULE: meta.surface.paint's slots are this client's ground iff their key is (painter, the params of gensurf, no
// season term) — the ground painter's (groundgen.js) and the Map's close zoom (maptiles.js) alike
export function paintHit(paint, painter, gensurf) {
  const K = paint && paint.key, p = gensurf ? paintParams(gensurf) : null;
  return !!(K && painter && K.painter === painter && p && K.params && K.params.strata === p.strata && K.params.tiling === p.tiling && K.season == null);
}
